import React, { useEffect, useState } from "react";
import Modal from "../../User/components/Modal"; // Adjust the path accordingly
import "../styles/pages/home.scss";
import Grid from "@mui/material/Grid2";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import applogo from "../assets/logo.svg";
import LocationOnIcon from "@mui/icons-material/LocationOn"; // Material UI icon for location
import overview_icon from "../../User/assets/icons/overview-icon.svg";
import editIcon from "../../User/assets/icons/register-upload-edit.svg";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const RegisterPage = ({ isRegisterModalOpen, handleCloseRegisterModal }) => {
  const [uploadImage, setUploadImage] = useState(null);
  const [image, setImage] = useState(null);
  const [mobileNumber, setMobileNumber] = useState();
  const [name, setName] = useState("");
  const [dob, setDob] = useState();
  const [gender, setGender] = useState("");
  const [location, setLocation] = useState("");
  const [otp, setOtp] = useState();
  const [resent,setresent] = useState();
  const [otpdisable, setOtpdisable] = useState(false);
  const [buttondisable, setButtondisable] = useState(true);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  //   const [otpDisplayer, setOtpDisplayer] = useState(false);
  const [errors, setErrors] = useState({
    mobileNumber: "",
    name: "",
    dob: "",
    gender: "",
    location: "",
    otp: "",
  });

  const handleCloseModal = () => {
    setUploadImage(null);
    setMobileNumber("");
    setName();
    setDob();
    setGender();
    setLocation();
    setOtp();
    setPrivacyChecked(false);
    handleCloseRegisterModal();
  };

  const handleUploadImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setUploadImage(URL.createObjectURL(file));
    }
  };

  const handleMobileNumberChange = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");

    if (value.length <= 10) {
      setMobileNumber(value);
      setErrors({ mobileNumber: "" });
    }
  };

  const fetchOtp = async () => {
    if (mobileNumber?.length !== 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        mobileNumber: "Please enter a valid mobile number",
      }));
      return;
    }
    setOtpdisable(true);
    try {
      const response = await instance.get(
        `Customer/sendOtp?mobile=${mobileNumber}`
      );
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setOtpdisable(false);
      setresent(true);
    }
  };

  const userRegistered = async () => {
    try {
      const formData = new FormData();
      formData.append("mobile", mobileNumber);
      formData.append("name", name);
      formData.append("dob", dob);
      formData.append("location", location);
      formData.append("otp", otp);
      formData.append("Gender", gender);
      formData.append("profile_pic", image);
      const response = await instance.post("Customer/Signup", formData);
      if (response.status === 200) {
        toast.success(response.data.message);
        handleCloseRegisterModal();
        setMobileNumber("");
        setName("");
        setDob("");
        setLocation("");
        setUploadImage("");
        setImage("");
        setGender("");
        setOtp("");
      }
    } catch (err) {
      console.log(err);
      return toast.error(err.response.data.message);
    }
  };

  const handleAutoDetect = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          // console.log(position);

          try {
            // Replace 'YOUR_GOOGLE_API_KEY' with your actual API key
            const apiKey = "AIzaSyAW-xZdNAskSJteiT9GmKfnFYRqfeZcWkc";
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
            );

            if (response.ok) {
              const responseData = await response.json();
              if (responseData.results && responseData.results.length > 0) {
                const address = responseData.results[0].formatted_address;
                // console.log("Detected Address:", address);
                setLocation(address); // Update location with the address
                toast.success("Location detected successfully!");
              } else {
                toast.error("No address found for the given location.");
              }
            } else {
              toast.error("Failed to fetch address. Please try again.");
            }
          } catch (error) {
            console.error("Error fetching address:", error);
            toast.error("Error fetching address. Please check your connection.");
          }
        },
        (error) => {
          console.error("Error detecting location:", error);
          toast.error("Location permission denied or unavailable.");
        }
      );
    } else {
      toast.error("Geolocation is not supported by your browser.");
    }
  };

  // Update buttondisable based on field completion
  useEffect(() => {
    if (
      mobileNumber &&
      name &&
      dob &&
      gender &&
      location &&
      otp &&
      uploadImage &&
      privacyChecked
    ) {
      setButtondisable(false);
    } else {
      setButtondisable(true);
    }
  }, [
    mobileNumber,
    name,
    dob,
    gender,
    location,
    otp,
    uploadImage,
    privacyChecked,
  ]);

  return (
    <React.Fragment>
      <Modal isOpen={isRegisterModalOpen} onClose={handleCloseModal}>
        <section className="regitser">
          <Grid
            container
            spacing={{ xs: 1.8, sm: 2, md: 3, lg: 4 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="login-image">
                <img src={applogo} alt="applogo" />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
              <div className="register-upload-image">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleUploadImage}
                  id="file-type"
                  style={{ display: "none" }}
                />
                <label htmlFor="file-type">
                  <img
                    className="profile-upload-image"
                    src={uploadImage ? uploadImage : overview_icon}
                    alt="profile"
                  />
                  <img className="edits-icon" src={editIcon} alt="edit" />
                </label>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <div className="admin-textfiled">
                <TextField
                  placeholder="Enter your full name"
                  label="Full name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  fullWidth
                  required
                />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <div className="admin-textfiled">
                <TextField
                  placeholder="Enter your mobile number"
                  label="Mobile number"
                  type="text"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  error={Boolean(errors.mobileNumber)}
                  helperText={errors.mobileNumber}
                  fullWidth
                  required
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button variant="text" onClick={fetchOtp} disabled={otpdisable}>
                          {resent === true ? "Resend OTP" : "Send OTP"}
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <div className="admin-textfiled">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Select DOB"
                    format="DD/MM/YYYY"
                    value={dob ? dayjs(dob) : null} // Ensure the value is a dayjs object
                    onChange={(newValue) => {
                      setDob(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth required />
                    )}
                    disableFuture
                  />
                </LocalizationProvider>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <div className="admin-textfiled">
                <TextField
                  placeholder="Enter OTP"
                  label="OTP"
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  fullWidth
                  required
                />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <div className="admin-textfiled">
                <FormControl fullWidth required>
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={gender}
                    label="Gender"
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
              <div className="admin-textfiled">
                <TextField
                  placeholder="Enter your Location"
                  label="Location"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  type="text"
                  fullWidth
                  requireds
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationOnIcon /> {/* Location icon */}
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button variant="text" onClick={handleAutoDetect}>
                          Auto detect
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="register-text">
                <Typography variant="h6">
                  <Checkbox
                    checked={privacyChecked}
                    onChange={(e) => setPrivacyChecked(e.target.checked)}
                    sx={{
                      color: "#9c9c9c ",
                      "&.Mui-checked": {
                        color: "#E37B00",
                      },
                    }}
                  />
                  I have read and accept the <span>Privacy Policy</span>
                </Typography>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="admin-textfiled">
                <Button
                  onClick={userRegistered}
                  disabled={buttondisable}
                  sx={{
                    backgroundColor: `${buttondisable ? "#9c9c9c" : "#E37B00"
                      } !important`,
                    color: "#fff !important",
                    border: "1px solid #E37B00 !important",
                    "&:hover": {
                      backgroundColor: `${!buttondisable ? "#D06900" : "#9c9c9c"
                        } !important`,
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#9c9c9c !important",
                      color: "#ffffff !important",
                    },
                  }}
                >
                  Register User
                </Button>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="copyright-text">
                <Typography variant="h5">
                  Terms & Conditions{" "}
                  <span>
                    Copyrights by <strong>Tailors4U</strong>
                  </span>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </section>
      </Modal>
    </React.Fragment>
  );
};

export default RegisterPage;
